import { useEffect, useState } from "react";

import { useProductServiceApi } from "@/api/hooks/productService.hook";
import {
    SafetyInfoDocument,
    SafetyInfoDocumentModel,
    SafetyInfoResponse
} from "@/api/mappers/safetyInfoDocument.mapper";
import { Messages } from "@/components/General/Messages/messages.container";
import {
    broadcastMessage,
    clearMessageById
} from "@/redux/modules/value/messages/messages.utils";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { SafetyInfo } from "./safetyInfo.component";

const SafetyInfoContainer = () => {
    const { t } = useGranite();
    const [documents, setDocuments] = useState<Array<SafetyInfoDocumentModel>>(
        []
    );
    const [search, setSearch] = useState<number | undefined>();
    const [{ data, error, loading }, get] = useProductServiceApi<
        unknown,
        SafetyInfoResponse,
        Array<SafetyInfoDocumentModel>
    >(
        {
            url: `/safetydocuments`,
            method: "GET",
            mapper: SafetyInfoDocument
        },
        {
            manual: true
        }
    );

    const showErrorMessage = () => {
        broadcastMessage({
            id: "product-safety-info-failure",
            text: t("productSafetyInfo.component.failure"),
            status: "danger",
            dismissible: false,
            activeScroll: true
        });
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (error) {
            setDocuments([]);
            // 404 - Not Found tonen we als input validatie fout
            if (error.status !== 404) {
                showErrorMessage();
            }
        } else {
            clearMessageById("product-safety-info-failure");
        }
    }, [error]);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        if (!search) {
            setDocuments([]);
            return;
        }

        const doGet = async () => {
            try {
                const response = await get({
                    params: {
                        search
                    }
                });

                if (!response || response.data.length === 0) {
                    showErrorMessage();
                }
            } catch {}
        };

        doGet();
    }, [search, get]);

    useEffect(() => {
        setDocuments(data || []);
    }, [data]);

    const onSubmit = (search: number) => {
        setSearch(search);
    };

    return (
        <>
            <Messages messageid="product-safety-info-failure" />
            <SafetyInfo
                isLoading={loading}
                safetyDocuments={documents}
                onSubmit={onSubmit}
                errorStatus={error?.status}
            />
        </>
    );
};

export { SafetyInfoContainer };
